import { useCallback, useEffect, useState } from 'react'

const useTabActive = () => {
  const [visibilityState, setVisibilityState] = useState<{
    visibility: boolean
    time: number | undefined
  }>({ visibility: false, time: 0 })

  const handleVisibilityChange = useCallback(() => {
    const timestamp = Date.now()
    const isVisible = document.visibilityState === 'visible'
    setVisibilityState(prevState => {
      return { visibility: isVisible, time: !isVisible ? timestamp : prevState?.time }
    })
  }, [])

  const handleFocus = useCallback(() => {
    setVisibilityState(prevState => {
      return { visibility: true, time: prevState?.time }
    })
  }, [])

  const handleBlur = useCallback(() => {
    const timestamp = Date.now()
    setVisibilityState({ visibility: false, time: timestamp })
  }, [])

  const handlePageShow = useCallback((event: PageTransitionEvent) => {
    if (event.persisted) {
      setVisibilityState(prevState => {
        return { visibility: true, time: prevState?.time }
      })
    }
  }, [])

  const handlePageHide = useCallback(() => {
    const timestamp = Date.now()
    setVisibilityState({ visibility: false, time: timestamp })
  }, [])

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange)

    window.addEventListener('focus', handleFocus)
    window.addEventListener('blur', handleBlur)

    window.addEventListener('pageshow', handlePageShow as EventListener)
    window.addEventListener('pagehide', handlePageHide)

    handleVisibilityChange()

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('focus', handleFocus)
      window.removeEventListener('blur', handleBlur)
      window.removeEventListener('pageshow', handlePageShow as EventListener)
      window.removeEventListener('pagehide', handlePageHide)
    }
  }, [handleVisibilityChange, handleFocus, handleBlur, handlePageShow, handlePageHide])

  return visibilityState
}

export default useTabActive
